module.exports = __webpack_public_path__ + "static/media/6841.b9f55785.jpg";